import { store } from "..";

const isUserHaveRole = (role) => {
  const user = store.getState()?.user;
  return user?.roleId === role;
};

export default isUserHaveRole;
